import { Route } from '@angular/router';

export const awardsRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('@rma/awards/overview'),
  },
  {
    path: 'checkout',
    loadChildren: () => import('@rma/awards/shop'),
  },
];
